<template>
  <div class="dropdown admin-profile">
    <div  id="dropdownProfile"
      class="d-xxl-flex align-items-center bg-transparent border-0 text-start p-0 cursor dropdown-toggle"
      data-bs-toggle="dropdown"
      type="button"
      @click="toggleDropdown"
      aria-expanded="false"
    >
      <div class="flex-shrink-0">
        <img
          class="rounded-circle wh-40 administrator"
          :src="`${api_url}/${user.avatar}`"
          alt="admin"
        />
      </div>
      <div class="flex-grow-1 ms-2">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-none d-xxl-block">
            <div class="d-flex align-content-center">
              <h3>{{ user.name }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="dropdown-menu border-0 bg-white dropdown-menu-end">
      <div class="d-flex align-items-center info">
        <div class="flex-shrink-0">
          <img
            class="rounded-circle wh-30 administrator"
            :src="`${api_url}/${user.avatar}`"
            alt="admin"
          />
        </div>
        <div class="flex-grow-1 ms-2">
          <h3 class="fw-medium">{{ user.fullName }}</h3>
          <span class="fs-12">{{ user.role }}</span>
        </div>
      </div>

      <ul class="admin-link ps-0 mb-0 list-unstyled">
        <li>
          <RouterLink
            class="dropdown-item d-flex align-items-center text-body"
            to="/settings/my-profile"
          >
            <i class="material-symbols-outlined">account_circle</i>
            <span class="ms-2">Mi Perfil</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink
            class="dropdown-item d-flex align-items-center text-body"
            to="/settings/change-password"
          >
            <i class="material-symbols-outlined">lock_reset</i>
            <span class="ms-2">Cambiar contraseña</span>
          </RouterLink>
        </li>
        <li>
          <RouterLink
            class="dropdown-item d-flex align-items-center text-body"
            to="/login"
          >
            <i class="material-symbols-outlined">logout</i>
            <span class="ms-2">Cerrar sesión</span>
          </RouterLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';
import { emitter } from '@/eventBus';

export default {
  name: "AdminProfile",
  setup() {
    const user = ref({}); 
    const api_url =  ref(String);
    onMounted(async () => {
      user.value = JSON.parse(localStorage.getItem("user"));
      api_url.value = process.env.VUE_APP_API_URL;

      const el = document.getElementById('dropdownProfile');
      if (el && window.bootstrap?.Dropdown) {
        new window.bootstrap.Dropdown(el); // Optional if data-bs-toggle is used
      }

      emitter.on('avatar-updated', (url) => { 
        
        user.value = JSON.parse(localStorage.getItem("user")); 
      });
    });

    const toggleDropdown = () => {
      const dropdownEl = document.getElementById('dropdownProfile');
      if (dropdownEl && window.bootstrap?.Dropdown) {
        const dropdown =window.bootstrap.Dropdown.getInstance(dropdownEl) || new window.bootstrap.Dropdown(dropdownEl);
        dropdown.toggle();
      }
    };
 
    return {
      user, api_url, toggleDropdown
    }
  }
};
</script>
